import { LoginService } from 'src/app/_core/services/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CadastroBem } from './../../../_core/models/cadastro-bem';
import { TipoMovimentacao } from './../../../_core/models/tipo-movimentacao';
import { Movimentacao } from './../../../_core/models/movimentacao';
import { MovimentacaoService } from './../../../_core/services/movimentacao.service';
import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import Swal from 'sweetalert2';
import { Usuario } from 'src/app/_core/models/usuario';
import { Observable, Subscription } from 'rxjs';
import { LocalizacaoService } from 'src/app/_core/services/localizacao.service';
import { Localizacao } from 'src/app/_core/models/localizacao';
import { Permissao } from 'src/app/_core/models/permissao';
import { CadastroBemService } from 'src/app/_core/services/cadastro-bem.service';

@Component({
  selector: 'app-tela-de-liberacao',
  templateUrl: './tela-de-liberacao.component.html',
  styleUrls: ['./tela-de-liberacao.component.scss']
})
export class TelaDeLiberacaoComponent implements OnInit {
  form!: FormGroup;
  public cadastro: CadastroBem[];
  movimentacao: Movimentacao;
  public data: Usuario[];
  data$: Observable<any[]>;
  cadastroSubscription: Subscription;
  local: Localizacao;
  keywordMatriculaDest = 'nome';
  keywordMatriculaOrigin = 'nome';
  keywordUnidade = 'dS_BPM_UNIDADE';
  keywordMeusBens = 'dS_BPM_DESCRICAO_BEM';
  descricaoBem = '';
  title = 'Tela de liberação';
  loading = true;
  user!: Usuario;
  usuario: Usuario;
  deletando: boolean = false;
  tipoMovimentacao!: TipoMovimentacao[];
  name: string = '';
  permissao: Permissao[];
  public localizacao: Localizacao[];
  isGestor: boolean;
  subordinado: any[];
  countInitialUser = null;

  constructor(
    private fb: FormBuilder,
    private movimentacaoService: MovimentacaoService,
    private loginService: LoginService,
    private cadastroBemService: CadastroBemService,
    private localizacaoService: LocalizacaoService,
    @Inject(DOCUMENT) private document: Document) {
    this.movimentacao = new Movimentacao();

  }

  ngOnInit(): void {
    this.loading = false;
    this.movimentacao = new Movimentacao();
    this.gerarForm();
    this.listarUser();
    this.listarLocalizacaoBensAll();
    this.user = JSON.parse(localStorage.getItem('currentUser')!);
    this.name = JSON.stringify(this.user.nome);
    this.authGestor();
  }
  authGestor() {
    this.loginService.authGestor().subscribe(
      data => {
        this.isGestor = data;
        if (this.isGestor === true) {
          this.loginService.getSubordinado().subscribe(
            data => {
              this.subordinado = data;
              this.subordinado.map(data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `);
            }
          )
        } else if (this.isGestor == false) {
          this.form.controls['cD_CDU_MATRICULA_ORIGEM'].setValue(JSON.stringify(this.user.cD_MATRICULA));
        };
      }
    )
  }
  selectDest(item: any) {
    const num = item.cD_MATRICULA
    this.form.get('cD_CDU_MATRICULA_DESTINO')?.setValue(num)
  }
  selecionaOrigem(item: any) {
    const num = item.cD_MATRICULA;
    this.form.controls['cD_CDU_MATRICULA_ORIGEM'].setValue(num);
    //console.log/"id: ", num);
  }
  selectEvent(item: any) {
    const num = item.cD_BPM_NR_UNIDADE
    this.form.get('cD_BPM_UNIDADE_OP_POSTERIOR')?.setValue(num)
  }

  listarUser() {
    setTimeout(() => {
      this.loginService.getAll()
        .pipe().subscribe(
          data => {
            this.data = data;
            this.data.map(data => data.nome = ` ${data.cD_MATRICULA} | ${data.nome} `)
          }
        )
    }, 300)



  }
  refresh() {
    this.document.location.reload();
  }
  gerarForm() {
    this.form = this.fb.group({
      dS_BPM_ETIQUETA_BEM: [null, [Validators.required]],
      cD_CDU_MATRICULA_ORIGEM: [null, [Validators.required]],
      cD_BPM_UNIDADE_OP_POSTERIOR: ['', []],
      cD_CDU_MATRICULA_DESTINO: [null, []],
      dS_BPM_SALA_POSTERIOR: [null, []],
      fL_BPM_DELETADO: [0, []]
    })
  }

  listarLocalizacaoBensAll() {
    this.localizacaoService.localizacaoAll()
      .subscribe(
        data => {
          this.localizacao = data;
          this.local = data;
        }
      )
  }

  getBem(){
    if(this.form.controls['dS_BPM_ETIQUETA_BEM'].value.length > 0) {
      this.cadastroBemService.listarBensByEtiqueta(this.form.controls['dS_BPM_ETIQUETA_BEM'].value)
      .subscribe(
        data => {
          this.descricaoBem = data.dS_BPM_DESCRICAO_BEM;
        }
      )
    }
  }
  clearInputUser() {
    this.form.controls['cD_CDU_MATRICULA_ORIGEM'].setValue(null);
    this.ngOnInit();
  }
  clearInputDest() {
    this.form.controls['cD_CDU_MATRICULA_DESTINO'].setValue(null);
  }
  clearInputLoc() {
    this.form.controls['cD_BPM_UNIDADE_OP_POSTERIOR'].setValue(null);
  }

  submit() {
    this.loading = true;
    if(this.form.controls['cD_CDU_MATRICULA_ORIGEM'].value !== null){
      this.form.get('cD_CDU_MATRICULA_ORIGEM')?.setValue(
        Number(this.form.controls['cD_CDU_MATRICULA_ORIGEM'].value));
    }
    if (this.form.controls['cD_BPM_UNIDADE_OP_POSTERIOR'].value == '') {
      this.form.controls['cD_BPM_UNIDADE_OP_POSTERIOR']?.setValue(0)
    }

    const movimentacao: Movimentacao = this.form.value;

    if (movimentacao.cD_CDU_MATRICULA_DESTINO == null) {
      movimentacao.cD_CDU_MATRICULA_DESTINO = 0
    }

    //console.log/movimentacao);
    if (this.form.invalid) {
      Swal.fire('Alerta', 'Olá digite os campos corretamente', 'warning');
      this.loading = false;
      return;
    }
    this.movimentacaoService.insert_liberar(movimentacao)
      .subscribe(
        data => {
          Swal.fire(
            'Sucesso!',
            data,
            'success'
          ).then(() => {
            this.loading = false;

          });
        },
        err => {
          this.loading = false;

        }
      )
  }


}
